
import { bezier } from 'styles/helpers'
import detect from 'helpers/detect'

const base = {
  animate: 'animate',
  exit: 'exit',
  initial: 'initial'
}

// const ease = bezier.principleOut
const invert = (v, invert) => v * (invert ? -1 : 1)
// const axe = (vertical) => vertical ? 'y' : 'x'

const willChange = (props) => (detect.safari ? {} : {
  willChange: 'transform, opacity', transitionEnd: { willChange: null }
})

const staggerChildren = (staggerChildren = 0.05, delayChildren = 0.3) => Object.assign({
  variants: {
    animate: {
      transition: { staggerChildren, delayChildren, staggerDirection: -1 }
    }
  }
}, base)

const pageAnimation = () => staggerChildren()
const pageAnimation2 = ({ distance = -40 } = {}) => {
  return {
    variants: {
      initial: { opacity: 0, y: -distance },
      exit: {
        opacity: 0,
        y: distance,
        ...willChange('opacity, transform'),
        transition: {
          duration: 0.5, ease: bezier.swiftOut
        }
      },
      animate: {
        opacity: 1,
        ...willChange('opacity, transform'),
        y: 0,
        transition: {
          duration: 0.5, ease: bezier.swiftOut
        }
      }
    }
  }
}

const popinAnimation = ({ distance = '50vh' } = {}) => {
  return {
    variants: {
      initial: { opacity: 0, y: '-' + distance },
      exit: {
        opacity: 0,
        y: distance,
        ...willChange('opacity, transform'),
        transition: {
          duration: 0.3, ease: bezier.swiftOut2, delay: 0.1
        }
      },
      animate: {
        opacity: 1,
        ...willChange('opacity, transform'),
        y: 0,
        transition: {
          duration: 0.4, ease: bezier.swiftOut2
        }
      }
    }
  }
}

const fadeAnimation = ({ easeIn = bezier.quadEaseOut, easeOut = bezier.quadEaseOut, duration = .3 } = {}) => {
  const _duration = duration

  return {
    variants: {
      initial: { opacity: 0.01 },
      exit: ({ duration } = {}) => ({
        opacity: 0,
        // ...willChange('opacity'),
        transition: {
          duration: duration || _duration, ease: easeOut
        }
      }),
      animate: {
        opacity: 1,
        // ...willChange('opacity'),
        transition: {
          duration: duration, ease: easeIn
        }
      }
    }
  }
}

const choiceAnimation = () => {
  return {
    variants: {
      initial: ({ inverted = false } = {}) => ({
        y: (invert(100, inverted) + '%'),
        opacity: 0
      }),
      exit: ({ inverted = false } = {}) => ({
        y: (invert(-100, inverted) + '%'),
        opacity: 0,
        ...willChange('transform, opacity'),
        transition: {
          duration: 0.6, ease: bezier.swiftOut
        }
      }),
      animate: {
        y: 0,
        opacity: 1,
        ...willChange('transform, opacity'),
        transition: {
          duration: 0.6, ease: bezier.swiftOut
        }
      }
    }
  }
}

const translate = ({ direction = 'y', initial = '100%', exit = '100%', animate = 0, duration = .4 } = {}) => {
  return Object.assign({
    variants: {
      initial: { [direction]: initial },
      exit: {
        [direction]: exit,
        ...willChange('transform'),
        transition: {
          duration, ease: bezier.swiftOut
        }
      },
      animate: {
        [direction]: animate,
        ...willChange('transform'),
        transition: {
          duration, ease: bezier.swiftOut
        }
      }
    }
  }, base)
}

export {
  translate,
  pageAnimation,
  pageAnimation2,
  staggerChildren,
  popinAnimation,
  fadeAnimation,
  choiceAnimation,
  base as baseAnimation
}
